import React, { useState } from 'react';
import { Button } from '../Button/index.js';
import { TransferList } from './TransferList.js';
function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}
function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
}
export function Transfer(props) {
    const { dataMetrics, dataTestId, listLeft, listRight, leftButtonName, rightButtonName, boxHeight, boxWidth } = props;
    const [checked, setChecked] = React.useState([]);
    const [left, setLeft] = useState(listLeft);
    const [right, setRight] = useState(listRight);
    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];
        if (currentIndex === -1) {
            newChecked.push(value);
        }
        else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };
    const handleCheckedRight = () => {
        setRight(right.concat(leftChecked));
        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
    };
    const handleCheckedLeft = () => {
        setLeft(left.concat(rightChecked));
        setRight(not(right, rightChecked));
        setChecked(not(checked, rightChecked));
    };
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'transfer', className: "tw-flex tw-flex-col tw-space-y-2" },
        React.createElement("div", { className: "tw-flex tw-space-x-4" },
            React.createElement(TransferList, { list: left, handleToggle: handleToggle, checked: checked, boxWidth: boxWidth, boxHeight: boxHeight }),
            React.createElement(TransferList, { list: right, handleToggle: handleToggle, checked: checked, boxWidth: boxWidth, boxHeight: boxHeight })),
        React.createElement("div", { className: "tw-flex tw-space-x-1 tw-justify-left" },
            leftButtonName && (React.createElement(Button, { appearance: "primary", disabled: leftChecked.length === 0, onClick: handleCheckedRight }, leftButtonName)),
            rightButtonName && (React.createElement(Button, { appearance: "primary", disabled: rightChecked.length === 0, onClick: handleCheckedLeft }, rightButtonName)))));
}
//# sourceMappingURL=Transfer.js.map